import { ComboBox, Text, IconButton, Label, Stack, Button, PrimaryButton, CommandButton, MessageBar, MessageBarType, IComboBoxOption, IComboBoxProps, SelectionMode } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import * as React from 'react';
import { IAgeGoup } from '../../../Models/AgeGroups/IAgeGroup';
import { emptyAttendee, IAttendee } from '../../../Models/Attendees/IAttendee';
import { IEvent } from '../../../Models/Event/IEvent';
import { IProfileContact } from '../../../Models/Profile/IProfileContact';
import { getAge } from '../../../Tools/DateTime';
import { AttendeePropertiesAdmin } from '../../Admin/Users/AttendeeProperties/AttendeePropertiesAdmin';
import { AttendeeDetailForm } from '../../Attendees/AttendeeDetail/AttendeeDetailForm';
import { AttendeeDetailView } from '../../Attendees/AttendeeDetail/AttendeeDetailView';
import { AttendeesListView } from '../../Attendees/AttendeesList/AttendeesListView';
import { maxAgeOdchod } from '../../Consts';

interface INewOrderStepAttendeeProps {
    userId: string;
    attendees: IAttendee[]
    goToStep: (step: number) => void;
    isAuth: boolean;
    goBack: () => void;
    addAttendee: (item: IAttendee) => void;
    selectAttendee: (item: IAttendee) => void;
    attendeesSelected: IAttendee[];
    removeSelectedAttendee: (id: number, userId: string) => void;
    event?: IEvent;
    profileContact: IProfileContact,
    email: string

}


export const NewOrderStepAttendee: React.FunctionComponent<INewOrderStepAttendeeProps> = (props) => {
    const [selectedAttendee, setSelectedAttendee] = React.useState<IAttendee>()
    const [selectedExists, setSelectedExists] = React.useState(false);
    const [isPropertiesPanelOpen, setIsPropertiesPanelOpen] = useBoolean(false);
    const [attendeeOptions, setAttendeeOptions] = React.useState<IComboBoxOption[]>([]);
    const [isFormValid, setIsFormValid] = React.useState(false);


    React.useEffect(() => {
        const options = props.attendees.map(item => {
            const o: IComboBoxOption = {
                key: item.id,
                text: item.firstName + " " + item.lastName,
            }
            return o;
        });
        setAttendeeOptions(options);
    }, [props.attendees]);

    React.useEffect(() => {
        let exits = false;
        if (selectedAttendee) {
            exits = props.attendeesSelected.find(x => x.id === selectedAttendee.id) != undefined
        }
        setSelectedExists(exits);
    }, [selectedAttendee, props.attendeesSelected])

    React.useEffect(() => {
        if (props.attendees.length === 0 && props.attendeesSelected.length === 0) {
            setSelectedAttendee(emptyAttendee(props.userId,
                props.profileContact.billingStreet,
                props.profileContact.billingCity,
                props.profileContact.billingPostalCode,
                props.profileContact.phoneNumber,
                props.email
            ));
        }
    }, []);

    const goToNextStep = () => {
        props.goToStep(5);
    }

    const addAttendee = () => {
        setSelectedAttendee(emptyAttendee(props.userId,
            props.profileContact.billingStreet,
            props.profileContact.billingCity,
            props.profileContact.billingPostalCode,
            props.profileContact.phoneNumber,
            props.email
        ));
        setIsPropertiesPanelOpen.setTrue();

    }

    const updateAttendee = (item: IAttendee)=>{

    }

    const createAttendee = (item: IAttendee) => {
        const s = props.attendeesSelected.find(x => x.id === item.id);
        if (!s) {
            if (getAge(item.dateOfBirth) >= maxAgeOdchod) {
                item.doprovod ="samostatně"
            }
            props.addAttendee(item);
            setIsPropertiesPanelOpen.setFalse();
        }
    }

    const propertyChanged = (key: string, value: any) => {
        if (selectedAttendee) {
            setSelectedAttendee({ ...selectedAttendee, [key]: value });
        }
    }

    const selectAttendee: IComboBoxProps['onChange'] = (event, option) => {
        if (option) {
            const s = props.attendees.find(x => x.id === option.key);
            if (s)
                setSelectedAttendee(s);
        }
    }

    const checkAge = () => {
        if (selectedAttendee && props.event) {
            const age = getAge(selectedAttendee.dateOfBirth);
            return (age >= props.event.minAge && age <= props.event.maxAge);
        }
      
        return ((props.event?.minAge === 0 && props.event?.maxAge === 0) || !selectedAttendee);
    }

    return (<Stack tokens={{ childrenGap: 20 }}>
      

        {(props.attendeesSelected.length !== 0 || props.attendees.length !== 0) ?
            <>
                <h2>{props.isAuth ? "Koho chci přihlásit?" : "Ještě někoho?"} </h2>
                {attendeeOptions.length > 0 ?
                    <Stack horizontalAlign="center" tokens={{ childrenGap: 20 }}>
                        <Stack horizontal verticalAlign="end" horizontalAlign="stretch">
                            <Stack grow>
                                <ComboBox selectedKey={selectedAttendee?.id} onChange={selectAttendee} placeholder="Vyberte jméno existujícího účastníka" label="Vyberte jméno existujícího účastníka a přidejte na přihlášku"
                                    options={attendeeOptions} />
                            </Stack>
                        </Stack>
                        {!checkAge() ?
                            <MessageBar messageBarType={MessageBarType.error} >Tato událost je určena pro věkovou skupinu {props.event?.minAge} - {props.event?.maxAge} let.Aktuálnímu účastníkovi je {selectedAttendee ? getAge(selectedAttendee.dateOfBirth) : ""}  </MessageBar> : null
                        }
                        <PrimaryButton disabled={!checkAge() || !selectedAttendee || selectedExists} text="Přidat na přihlášku" styles={{ root: { width: 250 } }} onClick={() => selectedAttendee && createAttendee(selectedAttendee)} />
                    </Stack> : null
                }
                <Stack tokens={{ childrenGap: 20 }}>
                    <AttendeesListView
                        userId={props.userId}
                        title=""
                        items={props.attendeesSelected} isLoading={false}
                        selectionMode={SelectionMode.single}
                        selectItem={function (item: IAttendee[]): void {
                            return;
                        }}
                        addAttendee={addAttendee}
                        deleteItem={props.removeSelectedAttendee} />
                </Stack>
            </>
            :
            selectedAttendee?
                <>
                    <h2>Koho chci přihlásit? </h2>
                    <AttendeeDetailForm paddingTop={0} isLoading={false} item={selectedAttendee} propertyChanged={propertyChanged} valid={setIsFormValid} minAge={props.event?.minAge} maxAge={props.event?.maxAge} />
                    <Stack horizontalAlign="center">
                        <PrimaryButton disabled={!isFormValid} text="Přihlásit osobu na akci" styles={{ root: { width: 250 } }} onClick={() => createAttendee(selectedAttendee)} />
                    </Stack>
                </> : null
            }

        {attendeeOptions.length > 0 ?
            <Stack horizontalAlign="center" wrap horizontal tokens={{ childrenGap: 10 }} styles={{ root: { paddingTop: 10 } }}>
                <Button text="< Zpět" onClick={props.goBack} />
                <PrimaryButton disabled={props.attendeesSelected.length === 0} text="Pokračovat >" onClick={goToNextStep} />
            </Stack> : null}
        
        {selectedAttendee ?
            <AttendeeDetailView
                item={selectedAttendee}
                isOpen={isPropertiesPanelOpen}
                isLoading={false}
                propertyChanged={propertyChanged}
                close={setIsPropertiesPanelOpen.setFalse}
                updateAttendee={updateAttendee}
                createAttendee={createAttendee}
                minAge={props.event?.minAge}
                maxAge={props.event?.maxAge}/>
            : null}
    </Stack>)
}
//{ props.attendeesSelected.length === 0 ? <MessageBar messageBarType={MessageBarType.info}>Pro pokračování musí být zadán alespoň jeden žák</MessageBar> : null }
